import { useMemo, useContext, Fragment } from "react";
import { useLocation } from "react-router-dom";

import { WithTooltip } from "../StyledComponents/WithTooltip";
import { AutherContext } from "../../Context";
import { sendGainsightEvent, KB_WEBSITE_GAINSIGHT_EVENTS } from "../../gainSightIntegration";

import { Wrapper, Link, ArrowImage, CapitalizeText } from "./styles";

import rightArrowIcon from "../../images/rightArrow.svg";

export const BreadCrumbs = ( { fullPath, ...props } ) => {

    const { search } = useLocation();

    const { userDetails } = useContext(AutherContext);
    const pathParts = useMemo( () => {
        if( !fullPath ) {
            return [];
        }
        return fullPath.split('/').filter( slug => !!slug).map( slug => {
            const name = slug.split('-').join(' ');
            return { name, slug };
        });
    }, [ fullPath ]);

    const handleClick = ({ slug, index }) => {
        const user_id = userDetails?.userDetails?.userId;
        const user_group_id = userDetails?.userDetails?.usergroupId
        sendGainsightEvent(KB_WEBSITE_GAINSIGHT_EVENTS.BREADCRUMB_CLICKED, {
            slug_name: slug,
            nesting_level: index,
            user_id,
            user_group_id
        });
    }

    const lastIndex = pathParts.length - 1;

    return ( 
    <Wrapper {...props}>
        <Link to={`/${search}`}>Homepage</Link>
        <ArrowImage src={rightArrowIcon} alt="right arrow" />
        { pathParts.map( ({ name, slug }, index) => (
            <Fragment key={slug}>
                <WithTooltip isNeeded={name.length > 24} content={<CapitalizeText>{name}</CapitalizeText>} size="180px" style={{ width: 'max-content' }}>
                    <Link to={`/${slug}${search}`} onClick={() => handleClick({ slug, index })}>{name}</Link>
                </WithTooltip>
                { index < lastIndex ? ( <ArrowImage src={rightArrowIcon} alt="right arrow" /> ) : null }
            </Fragment>
        ))}
    </Wrapper> )
}